module.exports = __webpack_public_path__ + "static/media/FFN-LOGO.a7b9815d.jpg";